const DRAG_THRESHOLD = 6;

const setupRatgeberTeaser = (root) => {
	const carousel = root.querySelector('[data-ratgeber-teaser-carousel]');
	if (!carousel) return;

	const isMobileSlider = () => window.matchMedia('(max-width: 1023px)').matches;

	let isPointerDown = false;
	let didDrag = false;
	let startX = 0;
	let startScrollLeft = 0;

	const stopDragging = () => {
		if (!isPointerDown) return;
		isPointerDown = false;
		carousel.classList.remove('cursor-grabbing');
		carousel.classList.add('cursor-grab');
	};

	carousel.addEventListener('mousedown', (event) => {
		if (!isMobileSlider() || event.button !== 0) return;
		isPointerDown = true;
		didDrag = false;
		startX = event.clientX;
		startScrollLeft = carousel.scrollLeft;
		carousel.classList.remove('cursor-grab');
		carousel.classList.add('cursor-grabbing');
		event.preventDefault();
	});

	window.addEventListener('mousemove', (event) => {
		if (!isPointerDown) return;
		const dx = event.clientX - startX;
		if (Math.abs(dx) > DRAG_THRESHOLD) {
			didDrag = true;
		}
		carousel.scrollLeft = startScrollLeft - dx;
	});

	window.addEventListener('mouseup', stopDragging);
	carousel.addEventListener('mouseleave', stopDragging);

	carousel.addEventListener(
		'click',
		(event) => {
			if (!didDrag) return;
			event.preventDefault();
			event.stopPropagation();
			didDrag = false;
		},
		true,
	);
};

const initRatgeberTeaser = () => {
	document.querySelectorAll('.ratgeber-teaser').forEach(setupRatgeberTeaser);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initRatgeberTeaser);
} else {
	initRatgeberTeaser();
}
